import type { IconRootProps } from './Root'
import { IconRoot } from './Root'

export function CloverIcon({ size = '1.5rem', ...props }: IconRootProps) {
  return (
    <IconRoot viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" size={size} {...props}>
      <path d="M5.99023 1.36779C6.70949 -0.455928 9.29051 -0.455931 10.0098 1.36779L10.9729 3.80993C11.1925 4.36672 11.6333 4.80747 12.1901 5.02706L14.6322 5.99023C16.4559 6.70949 16.4559 9.29051 14.6322 10.0098L12.1901 10.9729C11.6333 11.1925 11.1925 11.6333 10.9729 12.1901L10.0098 14.6322C9.29051 16.4559 6.70949 16.4559 5.99023 14.6322L5.02706 12.1901C4.80747 11.6333 4.36672 11.1925 3.80993 10.9729L1.36779 10.0098C-0.455928 9.29051 -0.455931 6.70949 1.36779 5.99023L3.80993 5.02706C4.36672 4.80747 4.80747 4.36672 5.02706 3.80993L5.99023 1.36779Z" />
    </IconRoot>
  )
}
